import Api from "../Utils/Axios";

export const GetAppNotificationList = async (data) => {
  const response = await Api.get(
    `appNotification?page=${data?.page}&limit=${data?.limit}&search=${data?.search}&phase=${data?.phase}&sortBy=${data?.sortBy || ""}&sortOrder=${data?.sortOrder || ""}`
  );
  return response.data;
};

export const DeleteNotifications = async (data) => {
  const response = await Api.delete(`appNotification/${data}`);
  return response.data;
};

export const CreateAppNotification = async (data) => {
  const response = await Api.post("appNotification/", data);
  return response.data;
};

export const GetSingleAppNotification = async ({ id }) => {
  const response = await Api.get(`appNotification/${id}`);
  return response.data;
};

export const UpdateAppNotification = async (id, data) => {
  const response = await Api.put(`appNotification/${id}`, data);
  return response.data;
};
